module.exports = __webpack_public_path__ + "assets/img/54aeb1b53775435391b771f3497e6ef5.webp";